import api from '../api';
import { buildSteps } from './instructions';

/**
 * Hämtar en rutt från OSRM och gör i ordning allt körvyn behöver.
 *
 * Påslaget per manöver finns för att sträcka delat med topphastighet ger
 * en orimligt optimistisk tid i tätort — en rondell kostar tid oavsett hur
 * fort fordonet får gå.
 */
const OSRM_URL = '/osrm';

const DELAY_PER_MANEUVER = {
  turn: 8, 'end of road': 10, fork: 5, 'new name': 3,
  roundabout: 12, rotary: 12, 'roundabout turn': 10,
  'enter roundabout': 12, 'exit roundabout': 5,
  'enter rotary': 12, 'exit rotary': 5,
  merge: 5, 'on ramp': 5, 'off ramp': 8,
  depart: 0, arrive: 0, continue: 2,
};
const DEFAULT_MANEUVER_DELAY = 5;

export default async function fetchRoute({ from, to, speedKmh }) {
  const [startLat, startLng] = from;
  const [destLat, destLng] = to;

  // exclude=motorway är verkningslöst mot EPA-profilen (som redan sätter
  // motorväg till hastighet 0) men fungerar som skydd om OSRM någon gång
  // byggs om med standardprofilen.
  const url = `${OSRM_URL}/route/v1/driving/${startLng},${startLat};${destLng},${destLat}`
    + '?overview=full&geometries=geojson&steps=true&exclude=motorway';

  const res = await api.get(url, { baseURL: '' });
  const route = res.data.routes && res.data.routes[0];
  if (!route) return null;

  const coords = route.geometry.coordinates.map(([lng, lat]) => [lat, lng]);

  const delaySeconds = (route.legs || [])
    .flatMap(leg => leg.steps || [])
    .reduce((total, step) => {
      const type = (step.maneuver && step.maneuver.type) || '';
      return total + (DELAY_PER_MANEUVER[type] ?? DEFAULT_MANEUVER_DELAY);
    }, 0);

  const plan = buildSteps(route.legs, coords);
  const distanceKm = route.distance / 1000;
  const minutes = Math.round((distanceKm / speedKmh) * 60 + delaySeconds / 60);

  return {
    coords,
    info: {
      speedKmh,
      delaySeconds,
      distanceKm,
      minutes,
      plan: { ...plan, route: coords },
    },
  };
}
